import { colors, font, mq } from '../consts/style';

export const theme = { colors, font, mq };
